export const notificationStyles = (prefix: string, iterator: number) => `
.${prefix}notification_with_wheel_${iterator} > .${prefix}notification__body >
.${prefix}notification__coupon {
  display: none;
  opacity: 0;
  bottom: -50px;
}

.${prefix}notification_with_wheel_${iterator} > .${prefix}notification__body >
.${prefix}notification__coupon._fadeIn {
  display: block;
  opacity: 1;
  bottom: 0;
  animation: fade_in_show 0.5s
}

.${prefix}notification_with_wheel_${iterator} > .${prefix}notification__body >
.${prefix}notification__message._fadeOut {
  display: none;
  opacity: 0;
  top: -50px;;
  animation: fade_out_show 0.5s
}

@keyframes fade_in_show {
     0% {
      opacity: 0;
      bottom: -50px;
     }

     100% {
      opacity: 1;
      bottom: 0;
     }
}

@keyframes fade_out_show {
     0% {
      opacity: 1;
      top 0px;
     }

     100% {
      opacity: 0;
      top: -50px;
     }
}

.${prefix}notification_with_wheel_${iterator} .${prefix}notification__coupon > .${prefix}notification__coupon-text._hidden {
  clip-path: initial !important;
}
`;
